package com.example.mystybag.core.logic.base

open class FeatureManager(): NavigatorConfig()

object FeatureManagers {
    data class Login(val config: NavigatorConfig): FeatureManager()

    object PersonalDetails: FeatureManager()

    data class UploadDocument(val config: NavigatorConfig, val closedCallback: (() -> Unit)? = null): FeatureManager()

}